import { ICourseCard } from 'models/courseCard.model'
import { IEnrolCard } from 'models/enrolCard.model'
import api from '..'

export interface TagRankingItem {
  id: string
  type: string
  attributes: {
    course: ICourseCard
    enrol: IEnrolCard
  }
}

const tagRanking = ({ page = 1, perPage = 8, search = '' }) => {
  return api
    .get<{ data: TagRankingItem[]; total: number }>('/courses/tag_ranking', {
      params: {
        page,
        per_page: perPage,
        search,
      },
    })
    .then(({ data }) => ({
      courses: data.data.map((item) => item.attributes),
      total: data.total,
    }))
}

export default tagRanking
